'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

// Ideally this is in a css file but it would not load properly
const styles: Record<string, React.CSSProperties> = {
  error: {
    height: '100vh',
    minHeight: '800px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    margin: '0',
    padding: '0',
    backgroundColor: '#65A989',
    backgroundImage:
      'url(https://www.nerdwallet.com/cdn/img/background/error/ErrorPage_BananaPeel_green.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    textAlign: 'center',
    alignItems: 'center',
  },
  h1: {
    color: 'white',
    margin: '0 auto',
    letterSpacing: '-0.67px',
    maxWidth: '350px',
    display: 'block',
  },
  button: {
    color: '#fff',
    background: '#6cc551',
    border: '1px solid transparent',
    padding: '7px 40px',
    height: '40px',
    borderRadius: '4px',
    letterSpacing: '-0.34px',
    textDecoration: 'none',
    cursor: 'pointer',
    maxWidth: '300px',
  },
};

const customerFacingErrorMessage = 'Sorry, looks like something slipped up.';

type ServerError = Error & { digest?: string };

function errorOccurredOnServer(error: ServerError): boolean {
  return Boolean(error.digest);
}

export default function GlobalError({ error }: { error: ServerError }) {
  useEffect(() => {
    datadogRum.addError(
      'Fatal Error! Customer saw the Banana Page. Investigate other errors that occurred during this session.',
    );
  }, []);

  return (
    <html lang="en">
      <body style={{ margin: 0 }}>
        <div style={styles.error}>
          <h1 style={styles.h1}>{customerFacingErrorMessage}</h1>

          {errorOccurredOnServer(error) && <p>Error Number: {error.digest}</p>}
          <button
            type="button"
            style={styles.button}
            onClick={
              // Attempt to recover by trying to re-render the segment
              () => {
                window.location.reload();
              }
            }
          >
            {`Let's try that again`}
          </button>
        </div>
      </body>
    </html>
  );
}
